
<component
  :is="as"
  class="nav-item"
  :class="{ collapsed, 'exact-match': exactMatch, admin }"
  v-bind="$attrs"
  v-on="$listeners"
  :title="collapsed ? text : ''"
>
  <icon :name="icon" />

  <div class="text-wrapper">
    <div class="text secondary-font">{{ text }}</div>
    <div v-if="subtext" class="subtext">{{ subtext }}</div>
  </div>

  <span class="slot-wrapper">
    <slot />
  </span>
</component>
